<button
  id="holdButton"
  class="accent transparent"
  mat-flat-button
  [class.waiting]="waiting"
  appStopPropagation
  (click)="hold()">
  <ng-container *ngIf="!waiting"> {{ 'button.hold' | translate }} </ng-container>

  <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
</button>
